import { useState, useRef, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../Common/http-common.js";
import * as common from "../../Common/common.js";
import * as Comp from "../../Common/CommonComponents.js";
import { GetPageAuthorityFn } from "../../Common/authority.js";
import { GetApplyLeavePermissionFn } from "../../Common/authority.js";
import ConfirmModal from '../../Components/BasicElements/ConfirmModal.js';
import { FileUpload } from 'primereact/fileupload';
import { Fieldset } from 'primereact/fieldset';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImport } from "@fortawesome/free-solid-svg-icons";

const PAGE_NAME = "Leave.js_";
const MODULE_ID = "WEB_AP_001";

const Leave = () => {
	const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [userName] = useState(cookies.USERNAME);
	const userReasonInputRef = useRef();
  
  function normalizeDate(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

	const [userListToBeSelect, setUserListToBeSelect] = useState([]);
  const [userList, setUserList] = useState([]);
	const [leaveTypeData, setLeaveTypeData] = useState([]);
	const [leaveSessionData, setLeaveSessionData] = useState([]);
  const [leaveType, setLeaveType] = useState([]);
  const [leaveSession, setLeaveSession] = useState([]);
  const [leaveBalance, setLeaveBalance] = useState([]);
  const [leaveTaken, setLeaveTaken] = useState([]);
  const [MTDBalance, setMTDBalance] = useState([]);
  const [leaveTakenByMTD, setLeaveTakenByMTD] = useState(false);
  const [leaveList, setLeaveList] = useState([]);
  const [disabledDates, setDisabledDates] = useState([]);
	const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
	const [noOfDays, setNoOfDays] = useState(0);
  
  const [shortLeaveTo, setShortLeaveTo] = useState(0);
  const [longLeaveTo_1, setLongLeaveTo_1] = useState(0);
  const [shortLeaveAdv, setShortLeaveAdv] = useState(0);
  const [longLeaveAdv_1, setLongLeaveAdv_1] = useState(0);
  const [longLeaveAdv_2, setLongLeaveAdv_2] = useState(0);

  const Today = new Date();
  const Year = new Date().getFullYear();
  const TodayMidnight = normalizeDate(Today);
  const TodayAfterLeaveTerm = new Date(TodayMidnight);
  const [selectedFiles, setSelectedFiles] = useState(undefined);
	const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);
  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [dateSingle, setDateSingle] = useState(undefined);
  const [uploadKey, setUploadKey] = useState(0);
  
	const handleDateChange = dates => {
    setInputError((prevState) => ({
      ...prevState,
      DATE_RANGE: (""),
    }));
    setDateRange(dates);
    calculateDays(dates);
  }
  
  const getYear = (d) => {
    if (!d) return null;
    const date = new Date(d);
    return isNaN(date) ? null : date.getFullYear();
  };

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });
  
  const [viewAuthority, setViewAuthority] = useState({
    ALL: "N",
    EL: "N",
  });

  useEffect(() => {
    let promise = GetPageAuthorityFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Dashboard");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
        toast.error(error);
        navigate("/Dashboard");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    let promise = GetApplyLeavePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setViewAuthority(result);
      },
      (error) => {
        setViewAuthority({
          ALL: "N",
          EL: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetApplyLeavePermissionFn", error);
        toast.error(error);
      }
    );
  }, [actionAuthority, userId])

  // #region useEffect
	useEffect(() => {
    let functionName = "";

    try {
      functionName = "Get Applicant Name";
      http
        .get(
          "api/leave/GetApplicantNameList?_sysUser=" + userId 
        )
        .then((response) => {
          const userlist = [];
          for (var i = 0; i < response.data.length; i++) {
            userlist.push({
              key: response.data[i].USER_MST_GUID,
              value: response.data[i].USER_MST_GUID,
              label: response.data[i].USERNAME,
            });
          }
          setUserListToBeSelect(userlist);
        })
        .catch((err) => {
          common.c_LogWebError(PAGE_NAME, functionName, err);
        });
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }, [userId]);

	useEffect(() => {
      let functionName = "";
      try {
        functionName = "useEffect Leave Type List";
        setLoading(true);
        setLoadingText("Getting Leave Type List, please wait...");

        http
          .get("api/leave/GetLeaveTypeList?_sysUser=" + userId, { timeout: 10000 })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].CATEGORY_TYPE_MST_ID,
                value: response.data[i].CATEGORY_TYPE_MST_ID,
                label: response.data[i].CATEGORY_TYPE_NAME,
              });
            }
            setLeaveTypeData(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting leave type list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
      } catch (err) {
        toast.error("Error on getting leave type list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
  }, [reload, userId]);

	useEffect(() => {
      let functionName = "";
      try {
        functionName = "useEffect Leave Session List";
        setLoading(true);
        setLoadingText("Getting Leave Session List, please wait...");

        http
          .get("api/leave/GetLeaveSessionList?_sysUser=" + userId, { timeout: 10000 })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].CATEGORY_TYPE_MST_ID,
                value: response.data[i].CATEGORY_TYPE_MST_ID,
                label: response.data[i].CATEGORY_TYPE_NAME,
              });
            }
            setLeaveSessionData(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting leave session list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
      } catch (err) {
        toast.error("Error on getting leave session list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
  }, [reload, userId]);

	useEffect(() => {
		let functionName = "";
			try {
				functionName = "useEffect Leave Balance";
				setLoading(true);
				setLoadingText("Getting Leave Balance, please wait...");
        const userRemain = viewAuthority.ALL === 'Y'
          ? userList.key
          : userId;
				const leaveId = leaveType.key === "886A7174-FCD9-42B9-A56B-8484810BA9FB" ? "1642D4D8-D21A-49C5-B823-0D92310089BE" : leaveType.key;
				http
					.get(
						"api/leave/GetUserLeave?_sysUser=" +
						 userId + 
						"&_userId=" +
						userRemain +
						"&_leaveId=" +
						leaveId, 
						 { timeout: 10000 })
					.then((response) => {
						const listItems = [];
						if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                listItems.push({
								key: response.data[0].USER_MST_GUID,
								balance: response.data[0].BALANCE_DAYS,
								taken: response.data[0].TAKEN_DAYS,
                mtdBalance: response.data[0].MTD_BALANCE,
                policy: response.data[0].POLICY_VALUE,
								});
							});
						}
            setLeaveBalance(response.data[0].BALANCE_DAYS);
            setLeaveTaken(response.data[0].TAKEN_DAYS);
            setMTDBalance(response.data[0].MTD_BALANCE);
            setLeaveTakenByMTD(response.data[0].POLICY_VALUE);
					})
					.catch((err) => {
            setLeaveBalance("0");
            setMTDBalance("0");
            setLeaveTaken("0");
					})
					.finally(() => {
						setLoading(false);
						setLoadingText("Loading...");
					});
			} catch (err) {
				toast.error("Error on getting user remaining leave. Please try again. 2");
				common.c_LogWebError(PAGE_NAME, functionName, err);
		}
	}, [actionAuthority, userId, userList, leaveType]);

  useEffect(() => {
    let functionName = "";

    try {
      functionName = "Get Leave Policy";
      http
        .get(
          "api/leave/GetLeavePolicy?_sysUser=" + userId, {timeout: 100000})
          .then((response) => {
            setEditData({
              SHORT_LEAVE_FROM: response.data[0].SHORT_LEAVE_FROM,
              LONG_LEAVE_FROM_1: response.data[0].LONG_LEAVE_FROM_1,
              LONG_LEAVE_FROM_2: response.data[0].LONG_LEAVE_FROM_2,
              SHORT_LEAVE_TO: response.data[0].SHORT_LEAVE_TO,
              LONG_LEAVE_TO_1: response.data[0].LONG_LEAVE_TO_1,
              LONG_LEAVE_TO_2: response.data[0].LONG_LEAVE_TO_2,
              SHORT_LEAVE_ADV: response.data[0].SHORT_LEAVE_ADV,
              LONG_LEAVE_ADV_1: response.data[0].LONG_LEAVE_ADV_1,
              LONG_LEAVE_ADV_2: response.data[0].LONG_LEAVE_ADV_2,
            })
          setShortLeaveTo(response.data[0].SHORT_LEAVE_TO);
          setLongLeaveTo_1(response.data[0].LONG_LEAVE_TO_1);
          setShortLeaveAdv(response.data[0].SHORT_LEAVE_ADV);
          setLongLeaveAdv_1(response.data[0].LONG_LEAVE_ADV_1);
          setLongLeaveAdv_2(response.data[0].LONG_LEAVE_ADV_2);
        })
        .catch((err) => {
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
      .finally(() => {
        setLoading(false);
      });
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }, [userId]);

  const handleDateSingleChange = date => {
    setInputError((prevState) => ({
      ...prevState,
      DATE_SINGLE: (""),
    }));
    setDateSingle(date);

    let currentDate = new Date(date);

    const holidayList = [];
    const userRemain = viewAuthority.ALL === 'Y'
          ? userList.key
          : userId;
    let functionName = "Get Holiday List";
    
    http
      .get(
        "api/leave/GetLeaveList?_sysUser=" + userRemain + 
        "&_startDate=" + common.c_Dis_DateTime(currentDate).val_datetime_YYYYMMDD + "&_endDate=" + common.c_Dis_DateTime(currentDate).val_datetime_YYYYMMDD
      )
      .then((response) => {
        for (var i = 0; i < response.data.length; i++) {
          holidayList.push({
            key: common.c_Dis_DateTime(new Date(response.data[i].APPLIED_DATE)).val_datetime_YYYYMMDD,
            id: response.data[i].APPLIED_DATE,
          });
        }

        const holidayDates = holidayList.map(holiday => holiday.key);
        const dateString = common.c_Dis_DateTime(currentDate).val_datetime_YYYYMMDD
        if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6 && !holidayDates.includes(dateString) ) {
          setNoOfDays(0.5);
        } else {
          setNoOfDays(0);
        }
      })
      .catch((err) => {
        common.c_LogWebError(PAGE_NAME, functionName, err);
      });
  }

	const calculateDays = dates => {
    if (dates[0] && dates[1]) {
      let currentDate = new Date(dates[0]);
      const end = new Date(dates[1]);
      let workingDays = 0;
      const holidayList = [];
      const userRemain = viewAuthority.ALL === 'Y'
          ? userList.key
          : userId;

      let functionName = "Get Holiday List";
      
      http
        .get(
          "api/leave/GetLeaveList?_sysUser=" + userRemain + 
          "&_startDate=" + common.c_Dis_DateTime(currentDate).val_datetime_YYYYMMDD + "&_endDate=" + common.c_Dis_DateTime(end).val_datetime_YYYYMMDD
        )
        .then((response) => {
          for (var i = 0; i < response.data.length; i++) {
            holidayList.push({
              key: common.c_Dis_DateTime(new Date(response.data[i].APPLIED_DATE)).val_datetime_YYYYMMDD,
              id: response.data[i].APPLIED_DATE,
            });
          }

          const holidayDates = holidayList.map(holiday => holiday.key);

          while (currentDate <= end) {
            const dateString = common.c_Dis_DateTime(currentDate).val_datetime_YYYYMMDD;
            // Exclude weekends (Saturday = 6, Sunday = 0)
            if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6 && !holidayDates.includes(dateString) ) {
              workingDays++;
            }
            currentDate.setDate(currentDate.getDate() + 1);
          }
          setNoOfDays(workingDays);
        })
        .catch((err) => {
          common.c_LogWebError(PAGE_NAME, functionName, err);
        });
    } else {
      setNoOfDays(0);
    }
  };

	useEffect(() => {
		let functionName = "";
			try {
				functionName = "useEffect Leave List";
				setLoading(true);
				setLoadingText("Getting Leave List, please wait...");
        const userRemain = viewAuthority.ALL === 'Y'
          ? userList.key
          : userId;

				http
					.get(
						"api/leave/GetLeaveList?_sysUser=" +
						 userRemain, { timeout: 10000 })
					.then((response) => {
						const listItems = [];
            const disabled = [];

						response.data.forEach(item => {
              const dateStr = item.APPLIED_DATE;
              const dateOnly = new Date(dateStr);

              listItems.push({
                key: dateStr,
                value: dateStr,
                label: dateStr,
              });

              if (!disabled.find(d => d.toDateString() === dateOnly.toDateString())) {
                disabled.push(dateOnly);
              }
            });

            setLeaveList(listItems);
            setDisabledDates(disabled);
					})
					.catch((err) => {
            toast.error("Error on getting leave list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
					})
					.finally(() => {
						setLoading(false);
						setLoadingText("Loading...");
					});
			} catch (err) {
				toast.error("Error on getting leave list. Please try again. 2");
				common.c_LogWebError(PAGE_NAME, functionName, err);
		}
	}, [actionAuthority, userId, userList]);
  // #endregion 

  //#region ONCLICK
  function ApplyLeave() {
    let functionName = "";
    let formData = new FormData();

    if (selectedFiles && selectedFiles.length > 0) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        if (file) {
          formData.append("files[]", file);
        }
      }
    }
    try {
      functionName = PAGE_NAME + ApplyLeave.name;
      setLoading(true);
      setLoadingText("Applying leave, please wait...");
      const selectedUser = viewAuthority.ALL === 'Y' ? userList.key : userId;
      const selectedLeave = leaveType.key;
      const selectedLeaveType = leaveType.label;
      const selectedLeaveSessionId = leaveSession?.key;
      const selectedLeaveSession = leaveSession?.label;
      const isSingleLeaveDate = ["951025A0-394A-4BC8-964D-EAD9CA43CC62", "8C909D4F-D999-43AE-8B45-AB7929E7D5C9"].includes(leaveSession.key);
      const selectedStartDate = 
        leaveSession.key = isSingleLeaveDate
        ? common.c_Dis_DateTime(dateSingle).val_datetime_YYYYMMDD
        : common.c_Dis_DateTime(startDate).val_datetime_YYYYMMDD;
      const selectedEndDate = 
        leaveSession.key = isSingleLeaveDate
        ? common.c_Dis_DateTime(dateSingle).val_datetime_YYYYMMDD
        : common.c_Dis_DateTime(endDate).val_datetime_YYYYMMDD;
      const calNoOfDays = noOfDays.toString();
      const inputReason = editData.REASON;
      const inputAttachment = selectedFiles && selectedFiles.length > 0
        ? selectedFiles.map(file => file.name).join(', ')
        : "";
      const isSessionLeave = ["1642D4D8-D21A-49C5-B823-0D92310089BE","886A7174-FCD9-42B9-A56B-8484810BA9FB"].includes(leaveType?.key);
      
      http
        .post(
          common.c_getApiUrl() +
          "api/leave/ApplyLeave", 
          formData, 
          {
            headers: {
              "Content-Type": "multipart/form-data",
              USER_MST_GUID: selectedUser,
              LEAVE_ID: selectedLeave,
              LEAVE_TYPE: selectedLeaveType,
              LEAVE_SESSION_ID: isSessionLeave ? selectedLeaveSessionId : "E502EADF-0AE5-4472-9CB6-CCC46B3DA9B5",
              LEAVE_SESSION: isSessionLeave ? selectedLeaveSession : "E502EADF-0AE5-4472-9CB6-CCC46B3DA9B5",
              START_DATE_STRING: selectedStartDate,
              END_DATE_STRING: selectedEndDate,
              NO_OF_DAYS_STRING: calNoOfDays,
              REASON: inputReason,
              FILENAME_ORI: inputAttachment,
              UPDATE_ID: userId,
              UPDATE_NAME: userName,
              FROM_SOURCE: JSON.stringify({ 
                SOURCE: "WEB", 
                MODULE_ID: MODULE_ID, 
              }),
            }
          }
        )
        .then((response) => {
          toast.success("Leave is successfully applied.");
          setUserList([]);
          setLeaveType([]);
          setLeaveSession([]);
          setDateSingle([]);
          setDateRange([]);
          setEditData([]);
          setSelectedFiles([]);
          setLeaveTakenByMTD(false);
          setNoOfDays(0);
          setUploadKey(prev => prev + 1);
        })
        .catch((err) => {
          const errorData = err.response?.data || {};
          if (errorData.VALID === "DATE_REPEAT") {
            toast.error(errorData.ERROR_MSG);
            common.c_LogWebError(PAGE_NAME, functionName, err);
          } else if (errorData.VALID === "PENDING_LEAVE") {
            toast.error(errorData.ERROR_MSG);
            common.c_LogWebError(PAGE_NAME, functionName, err);
          } else {
            toast.error("Failed to apply leave. Please try again.1");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          }
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
    } catch (err) {
        setLoading(false);
        setLoadingText("Loading...");
        toast.error("Failed to apply leave. Please try again.2");
        common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }
	//#endregion

	//#region HANDLER
	const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: `${name} could not be empty.`,
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }

	const selectUserHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectUserHandler.name;
      if (val && Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          USERNAME: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          USERNAME: "User could not be empty.",
        }));
      }
      setUserList(val);
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }

  const selectLeaveHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectLeaveHandler.name;
      if (val && Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          LEAVE_TYPE: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          LEAVE_TYPE: "Leave Type could not be empty.",
        }));
      }
      setInputError((prevState) => ({
        ...prevState,
        LEAVE_SESSION: "",
        ATTACHMENT: "",
      }));
      setLeaveType(val);
      setLeaveSession([]);
      setDateRange([null,null]);
      setNoOfDays("0");
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }

  const selectLeaveSessionHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectLeaveSessionHandler.name;
      if (val && Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          LEAVE_SESSION: "",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          LEAVE_SESSION: "Leave Session could not be empty.",
        }));
      }
      setLeaveSession(val);
      setDateRange([null,null]);
      setDateSingle(undefined);
      setNoOfDays("0");
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }

  const selectFileHandler = (event) => {
    const files = event.files;

    const validExtensions = ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'xls', 'xlsx'];
    const invalidFiles = [];

    for (let file of files) {
      const ext = file.name.split('.').pop().toLowerCase();
      if (!validExtensions.includes(ext)) {
        invalidFiles.push(file.name);
      }
    }

    if (invalidFiles.length > 0) {
      setInputError((prevState) => ({
        ...prevState,
        ATTACHMENT: "Invalid file type. Please upload .png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, or .xlsx.",
      }));
    } else {
      setInputError((prevState) => ({
        ...prevState,
        ATTACHMENT: "",
      }));
      setSelectedFiles(files);
    }
  };

  const removeFileHandler = (event) => {
    const updatedFiles = selectedFiles.filter(f => f.name !== event.file.name);
    setSelectedFiles(updatedFiles);

    // if (leaveType.key === 'D80DF667-D6BF-43AA-93A1-441C99663C04' && updatedFiles.length === 0) {
    //   setInputError((prevState) => ({
    //     ...prevState,
    //     ATTACHMENT: "Attachment is required for Medical Leave.",
    //   }));
    // } else {
    //   setInputError((prevState) => ({
    //     ...prevState,
    //     ATTACHMENT: "",
    //   }));
    // }
  };
  
  const onReloadHandler = () => {
		setReload(!reload);
	};
  
  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const handleConfirm = () => {
    var flag = true;
    const hasNoFiles =
      selectedFiles === undefined ||
      selectedFiles === null ||
      (Array.isArray(selectedFiles) && selectedFiles.length === 0);

    if (noOfDays <= shortLeaveTo) {
      TodayAfterLeaveTerm.setDate(TodayAfterLeaveTerm.getDate()+shortLeaveAdv);
    } else if (noOfDays > shortLeaveTo && noOfDays <= longLeaveTo_1) {
      TodayAfterLeaveTerm.setDate(TodayAfterLeaveTerm.getDate()+longLeaveAdv_1);
    } else {
      TodayAfterLeaveTerm.setDate(TodayAfterLeaveTerm.getDate()+longLeaveAdv_2);
    }

    if (viewAuthority.ALL === 'Y' && (userList.length === 0 || userId.length === 0)) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				USERNAME: ("Applicant could not be empty."),
			}));
		}

		if (leaveType.length === 0) {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				LEAVE_TYPE: ("Leave Type could not be empty."),
			}));
		}

    if ((leaveType?.key === "1642D4D8-D21A-49C5-B823-0D92310089BE" || leaveType?.key === "886A7174-FCD9-42B9-A56B-8484810BA9FB") && leaveSession.length === 0) { //leave type = annual || emergency
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				LEAVE_SESSION: ("Leave Session could not be empty."),
			}));
		}

    if (leaveSession.key === "E502EADF-0AE5-4472-9CB6-CCC46B3DA9B5" && leaveType.key === "1642D4D8-D21A-49C5-B823-0D92310089BE") { //leave session = full day && leave type = annual
      if (!startDate || !endDate) {
        flag = false;
        setInputError((prevState) => ({
          ...prevState,
          DATE_RANGE: ("Date Range could not be empty."),
        }));
      } else if (getYear(startDate) !== getYear(endDate)) {
        flag = false;
        setInputError((prevState) => ({
          ...prevState,
          DATE_RANGE: (`Date applied must be same year.`),
        }));
      } else if (startDate < TodayAfterLeaveTerm ){
        if (noOfDays <= shortLeaveTo) {
          flag = false;
          setInputError((prevState) => ({
            ...prevState,
            DATE_RANGE: ("Annual Leave less than " + shortLeaveTo + " days must be submitted " + shortLeaveAdv + " days in advance."),
          }));
        } else if (noOfDays > shortLeaveTo && noOfDays <= longLeaveTo_1) {
          flag = false;
          setInputError((prevState) => ({
            ...prevState,
            DATE_RANGE: ("Annual Leave exceeding " + shortLeaveTo + " days and up to " + longLeaveTo_1 + " days must be submitted " + longLeaveAdv_1 + " days in advance."),
          }));
        }
        else {
          flag = false;
          setInputError((prevState) => ({
            ...prevState,
            DATE_RANGE: ("Annual Leave exceeding " + longLeaveTo_1 + " days must be submitted " + longLeaveAdv_2 + " days in advance."),
          }));
        }
      }
    } else if (leaveSession.key !== "E502EADF-0AE5-4472-9CB6-CCC46B3DA9B5" && (leaveType.key === "1642D4D8-D21A-49C5-B823-0D92310089BE" || leaveType.key === "886A7174-FCD9-42B9-A56B-8484810BA9FB")){ // full day && (annual || emergency)
      if (!dateSingle) {
        flag = false;
        setInputError((prevState) => ({
          ...prevState,
          DATE_SINGLE: ("Date could not be empty."),
        }));
      } else if (leaveType.key === "1642D4D8-D21A-49C5-B823-0D92310089BE" && dateSingle < TodayAfterLeaveTerm){ // annual
        if (noOfDays <= shortLeaveTo) {
          flag = false;
          setInputError((prevState) => ({
            ...prevState,
            DATE_SINGLE: ("Annual Leave less than " + shortLeaveTo + " days must be submitted " + shortLeaveAdv + " days in advance."),
          }));
        } else if (noOfDays > shortLeaveTo && noOfDays <= longLeaveTo_1) {
          flag = false;
          setInputError((prevState) => ({
            ...prevState,
            DATE_SINGLE: ("Annual Leave exceeding " + shortLeaveTo + " days and up to " + longLeaveTo_1 + " days must be submitted " + longLeaveAdv_1 + " days in advance."),
          }));
        }
        else {
          flag = false;
          setInputError((prevState) => ({
            ...prevState,
            DATE_SINGLE: ("Annual Leave exceeding " + longLeaveTo_1 + " must be submitted " + longLeaveAdv_2 + " days in advance."),
          }));
        }
      }
    } else if (leaveType.key !== "1642D4D8-D21A-49C5-B823-0D92310089BE" || leaveType.key !== "886A7174-FCD9-42B9-A56B-8484810BA9FB") { //annual || emergency
      if (!startDate || !endDate) {
        flag = false;
        setInputError((prevState) => ({
          ...prevState,
          DATE_RANGE: ("Date Range could not be empty."),
        }));
      }
    }

    if ((getYear(startDate) == Year && getYear(endDate) == Year) || getYear(dateSingle) == Year) {
      if (leaveType.key !== "977AEEA0-803B-43F3-A0FC-8C2410B535F6") { //unpaid
        if((leaveType.key === "1642D4D8-D21A-49C5-B823-0D92310089BE" || leaveType.key === "886A7174-FCD9-42B9-A56B-8484810BA9FB") && leaveTakenByMTD && noOfDays > MTDBalance) { //annual || emergency
          flag = false;
          setInputError((prevState) => ({
            ...prevState,
            LEAVE_TYPE: ("Insufficient MTD leave balance."),
          }));
        } else {
          if (noOfDays > leaveBalance) {
            flag = false;
            setInputError((prevState) => ({
              ...prevState,
              LEAVE_TYPE: ("Insufficient leave balance."),
            }));
          }
        }
      }
    }

    if (editData.REASON === undefined || editData.REASON === "") {
      flag = false;
			setInputError((prevState) => ({
				...prevState,
				REASON: ("Reason could not be empty."),
			}));
		}

    // if (leaveType.key === 'D80DF667-D6BF-43AA-93A1-441C99663C04' && hasNoFiles) {
    //   flag = false;
    //   setInputError((prevState) => ({
		// 		...prevState,
		// 		ATTACHMENT: ("Attachment could not be empty for Medical Leave."),
		// 	}));
		// } else {
    //   setInputError((prevState) => ({
		// 		...prevState,
		// 		ATTACHMENT: "",
		// 	}));
    // }
    
		if (flag != false) {
      setShowConfirmModal(true);
    }
  };

  const handleConfirmModal = () => {
    ApplyLeave();
    setShowConfirmModal(false); // Hide confirm modal
  };

	const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide confirm modal
  };
  //#endregion

	return (
    <>
		<div className="Panel" style={{ padding: "12px" }}>
			<div className="applypanel" style={{ backgroundColor: "white" }}>
        <Fieldset className="leaveFieldset">
          <legend className="leaveLegend">
            Leave Application Policy
          </legend>

          <p style={{ color: "black", fontSize: "13px" }}>
            <b>Purpose</b><br></br>
            This policy aims to ensure porper planning, smooth workflow, and fairness in leave management.
            Employeees are encouraged to plan their leave in advance to minimize disruption to operations.
          </p><hr></hr>

          <p style={{ color: "black", fontSize: "13px" }}>
            <b>Leave Duration & Application Timeline</b><br></br>
            <b>1.&nbsp;&nbsp;&nbsp;&nbsp;Short Leave</b> 
            <ul>
              <li>
                For leave applications of <b style={{ color: "red" }}> {editData.SHORT_LEAVE_TO} days or less</b>, the request must be submitted at least
                <b style={{ color: "red" }}> {editData.SHORT_LEAVE_ADV} days</b> in advance.
              </li>
              <li>Late submission will be treated as <b style={{ color: "red" }}>emergency leave</b>.</li>
            </ul>
          </p>

          <p style={{ color: "black", fontSize: "13px" }}>
            <b>2.&nbsp;&nbsp;&nbsp;&nbsp;Long Leave</b> 
            <ul>
              <li>
                For leave applications exceeding <b style={{ color: "red" }}> {editData.SHORT_LEAVE_TO} days and up to {editData.LONG_LEAVE_TO_1} days</b>,
                the request must be submitted at least
                <b style={{ color: "red" }}> {editData.LONG_LEAVE_ADV_1} days</b> in advance.
              </li>
              <li>
                For leave applications exceeding <b style={{ color: "red" }}> {editData.LONG_LEAVE_TO_1} days</b>, the request must be submitted at least
                <b style={{ color: "red" }}> {editData.LONG_LEAVE_ADV_2} days</b> in advance.
              </li>
            </ul>
          </p>

          <p style={{ color: "black", fontSize: "13px" }}>
            <b>3.&nbsp;&nbsp;&nbsp;&nbsp;Emergency Leave</b>
            <ul>
              <li>Should only be used for <b>unforeseen or urgent circumstances</b>.</li>
              <li>Please contact your manager directly to apply.</li>
              <li>Approval will be subject to management's review and the validity of the reason provided.</li>
            </ul>
          </p><hr></hr>

          <p style={{ color: "black", fontSize: "13px" }}>
            <b>NOTE</b><br></br>
            Any leave balance carried forward from the previous year must be utilized within the year. Unused balance will be forfeited thereafter.
          </p>
        </Fieldset>
      </div>
			<div className="applypanel" style={{ backgroundColor: "white" }}>
        <table className="custom-table-apply" style={{ marginTop: "10px" }}>
          <tr>
            <td colSpan="4" style={{ fontSize: "14px" }}>
              {viewAuthority.ALL === 'Y' ? (
              <Comp.Select
                id="USERNAME"
                label="Applicant*"
                type="text"
                name="USERNAME"
                options={userListToBeSelect}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                errorMessage={inputError.USERNAME}
                value={userList}
                onChange={selectUserHandler}
                isMulti={false}
              />
              ):(
              <Comp.Select
                id="USERNAME"
                label="Applicant*"
                type="text"
                name="USERNAME"
                hideSelectedOptions={true}
                value={{
                  key: userId,
                  value: userId,
                  label: userName,
                }}
                readOnly={true}
              />
              )}
            </td>
          </tr>
          <tr>
            <td colSpan="2" style={{ paddingRight: "5px", fontSize: "14px" }}>
              <Comp.Select
                id="LEAVE_TYPE"
                label="Leave Type*"
                type="text"
                name="LEAVE_TYPE"
                options={
                  viewAuthority.EL === 'Y'
                    ? leaveTypeData
                    : leaveTypeData.filter(opt => opt.key !== "886A7174-FCD9-42B9-A56B-8484810BA9FB")
                }
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                value={leaveType}
                onChange={selectLeaveHandler}
                errorMessage={inputError.LEAVE_TYPE}
              />
              {leaveType && (
                <div style={{ fontSize: "0.7rem", textAlign: "right" }}>
                  <span style={{ color: "#000" }}>YTD:</span> {Math.max(0, leaveBalance ?? 0)},&nbsp;<span style={{ color: "#000" }}>MTD:</span> {Math.max(0, MTDBalance ?? 0)},&nbsp;
                  <span style={{ color: "#000" }}>Taken:</span> {leaveTaken}
                </div>
              )}
            </td>
            <td colSpan="2" style={{ fontSize: "14px" }}>
              <Comp.Select
                id="LEAVE_SESSION"
                label={`Leave Session${(leaveType?.key === "1642D4D8-D21A-49C5-B823-0D92310089BE" || leaveType?.key === "886A7174-FCD9-42B9-A56B-8484810BA9FB") ? "*" : ""}`}
                type="text"
                name="LEAVE_SESSION"
                options={leaveSessionData}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                value={(leaveType?.key === "1642D4D8-D21A-49C5-B823-0D92310089BE" || leaveType?.key === "886A7174-FCD9-42B9-A56B-8484810BA9FB") ? leaveSession : ""}
                onChange={selectLeaveSessionHandler}
                isDisabled={leaveType?.key !== "1642D4D8-D21A-49C5-B823-0D92310089BE" && leaveType?.key !== "886A7174-FCD9-42B9-A56B-8484810BA9FB"}
                errorMessage={inputError.LEAVE_SESSION}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="2" style={{ fontSize: "14px" }}>
              {
                (leaveType.key === "1642D4D8-D21A-49C5-B823-0D92310089BE" || leaveType.key === "886A7174-FCD9-42B9-A56B-8484810BA9FB") && (leaveSession.key === "951025A0-394A-4BC8-964D-EAD9CA43CC62" || leaveSession.key === "8C909D4F-D999-43AE-8B45-AB7929E7D5C9") ? (
                  <Comp.DateTimePicker
                    id="DATE_SINGLE"
                    label="Date*"
                    className="form-control-apply"
                    onChange={handleDateSingleChange}
                    selected={dateSingle}
                    placeholderText="Select date"
                    errorMessage={inputError.DATE_SINGLE}
                    autoComplete="off"
                    excludeDates={disabledDates}
                    filterDate={(date) => date.getDay() !== 0 && date.getDay() !== 6}
                  />
                ) : leaveType.key === undefined || ((leaveType.key === "1642D4D8-D21A-49C5-B823-0D92310089BE" || leaveType.key === "886A7174-FCD9-42B9-A56B-8484810BA9FB") && leaveSession.key === undefined) ? (
                  <Comp.Input
                    id="DATE_EMPTY"
                    label="Date Range*"
                    className="form-control"
                    readOnly={true}
                  /> 
                ) : (
                  <Comp.DateTimePicker
                    id="DATE_RANGE"
                    label="Date Range*"
                    className="form-control-apply"
                    selectsRange
                    onChange={handleDateChange}
                    startDate={startDate}
                    endDate={endDate}	
                    placeholderText="Select date range"
                    errorMessage={inputError.DATE_RANGE}
                    autoComplete="off"
                    filterDate={(date) => date.getDay() !== 0 && date.getDay() !== 6 && 
                      !disabledDates.some(disabled =>
                      disabled.toDateString() === date.toDateString()
                    )}
                  />
                )
              }
              <div style={{ fontSize: "0.7rem", textAlign: "right" }}>
                <span style={{ color: "#000" }}>Total Days (s):</span> {noOfDays}
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan="4" style={{ fontSize: "14px" }}>
              <Comp.Input
                ref={userReasonInputRef}
                id="REASON"
                label="Reason*"
                name="Reason"
                type="text"
                className="form-control"
                errorMessage={inputError.REASON}
                value={editData.REASON}
                onChange={inputRequiredHandler}
                autoComplete="off"
              />
            </td>
          </tr>
          <tr>
            <td colSpan="4" style={{ fontSize: "14px" }}>
              <div style={{ marginBottom: "6px" }}>Attachment{leaveType?.key === "D80DF667-D6BF-43AA-93A1-441C99663C04" && <span>*</span>}</div>
              <FileUpload key={uploadKey} name="demo[]" url={'/api/upload'} multiple accept="image/*" maxFileSize={1000000} 
                customUpload onSelect={selectFileHandler} onRemove={removeFileHandler} showUploadButton={false} showCancelButton={false} 
                emptyTemplate={<p style={{ fontSize: "0.8rem"}}>Drag and drop files to here to upload.</p>}
                className="p-fileupload-sm"
              />
              {inputError.ATTACHMENT && (
                <div style={{ color: "#dc3545", fontSize: "85%", marginTop: "3px", marginBottom: "9px" }}>
                  {inputError.ATTACHMENT}
                </div>
              )}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "20px 5px", fontSize: "14px" }}>
              <Comp.Button 
                id="btnSave" 
                onClick={handleConfirm}
                onLoading={onLoadingHandler}
                >
                Submit  <FontAwesomeIcon icon={faFileImport} />
              </Comp.Button>
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
		</div>

    {/* Confirm Modal */}
    <ConfirmModal
      show={showConfirmModal}
      onHide={handleConfirmModalClose}
      onConfirm={handleConfirmModal}
      prop="Confirm to apply"
    >
      Are you sure you want to apply this leave?
    </ConfirmModal>

    {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
		</>
	)
}

export default Leave;